import Vue from 'vue'

export default {
  setExcelLayersKeyValue(state, data) {
    state[data.key] = data.value
  },

  setExcelLayerField(state, { layerId, fieldName, fieldValue }) {
    const excelLayer = state.excelLayerList.find((excelLayerItem) => {
      return excelLayerItem.id === layerId
    })

    if (excelLayer) {
      excelLayer[fieldName] = fieldValue
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/excel-layers/mutations.js